var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"title":"Download CSV File","outlined":""},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false),[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-download")]),_vm._v(" "+_vm._s(_vm.text || 'Download')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }